export const ArrowClosed = () => (
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="48" height="48" rx="10" fill="white" />
    <path
      d="M16 20.5L24 28.5L32 20.5"
      stroke="#636B7A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
